import { keyframes, styled } from '../setup'
import { colors, spacing, typography } from '../theme'

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`

const Container = styled('div')<{ fullScreen?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${(props) =>
    props.fullScreen &&
    `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(250, 250, 250, 0.95);
    z-index: 1000;
  `}
  ${(props) =>
    !props.fullScreen &&
    `
    padding: ${spacing['4xl']};
  `}
`

const Spinner = styled('div')<{ size?: number }>`
  width: ${(props) => props.size || 40}px;
  height: ${(props) => props.size || 40}px;
  border: 3px solid ${colors.border};
  border-top-color: ${colors.accentPrimary};
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`

const Message = styled('p')`
  color: ${colors.textSecondary};
  margin-top: ${spacing.lg};
  font-size: ${typography.fontSizeBase};
`

interface LoadingProps {
  fullScreen?: boolean
  message?: string
  size?: number
}

export function Loading({ fullScreen, message, size }: LoadingProps) {
  return (
    <Container fullScreen={fullScreen}>
      <Spinner size={size} />
      {message && <Message>{message}</Message>}
    </Container>
  )
}
